import { addColumnHeader } from "../helpers";

export const switchColumns = (
  worksheet,
  outputSheet,
  rules,
  rule,
  fileSettings,
  inputColumns,
  outputColumns,
) => {
  Object.entries(rule.switchColMappings).forEach(([key, value]) => {
    addColumnHeader(outputSheet, outputColumns, value);
  });

  const useOutputOf = rules.find(
    (rle) => parseInt(rle._id) === parseInt(rule.useOutputOf),
  );

  if (useOutputOf) {
    if (useOutputOf.ranges) {
      shiftDataUsingRanges(
        worksheet,
        outputSheet,
        rule.switchColMappings,
        useOutputOf.output,
      );
    } else {
      shiftDataUsingIndices(
        worksheet,
        outputSheet,
        rule.switchColMappings,
        useOutputOf.output,
      );
    }
  }
};

const shiftDataUsingIndices = (
  worksheet,
  outputSheet,
  columnMappings,
  dateIndices,
) => {
  let outputRow = { current: 2 };
  dateIndices.forEach((rowIndex) => {
    fetchAndPaste(worksheet, outputSheet, columnMappings, rowIndex, outputRow);
  });
};

const shiftDataUsingRanges = (
  worksheet,
  outputSheet,
  columnMappings,
  dateIndices,
) => {
  let outputRow = { current: 2 };

  dateIndices.forEach(([startIndex, endIndex]) => {
    for (let rowIndex = startIndex + 1; rowIndex <= endIndex; rowIndex++) {
      fetchAndPaste(
        worksheet,
        outputSheet,
        columnMappings,
        rowIndex,
        outputRow,
      );
    }
  });
};

const fetchAndPaste = (
  worksheet,
  outputSheet,
  columnMappings,
  rowIndex,
  outputRow,
) => {
  Object.entries(columnMappings).forEach(([key, value]) => {
    let inputCellValue = worksheet.getCell(`${key}${rowIndex}`).value;
    outputSheet.getCell(`${value}${outputRow.current}`).value = inputCellValue;
    outputRow.current++;
  });
};
